module.exports = __webpack_public_path__ + "img/horizontal_5_1_8011.aadf9307.png";